import type { FaireProductEntity } from "../../entity_types/product";

export const p_7f8f4ym8gh: FaireProductEntity = {
  token: "p_7f8f4ym8gh",
  type: "product",
  name: "Tea Tree Cream – Relief for Fungus, Yeast & Candida",
  brandToken: "b_129dsr49u5",
  brandName: "Taylor Made Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/7e45abf547d0696ed0ad5f62d46b7e294fe57af04658b3f6e54356d554f6ff56.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0c2a6c79ac8f46c81134756e14201afb18ff21a4566c6e8432b1ff770ecb464e.png",
    "https://cdn.faire.com/fastly/39142beb2aa77e55e0b92b92c1c26ac45a35b3dcb67d54a0f2e20c78d9c04c11.png",
    "https://cdn.faire.com/fastly/22509ff26870d7554c213a7760c9e817ffe835478ffbd0f7c5d52c2fbb8bb7a2.png",
  ],
  priceDollars: 11.5,
  description:
    "Therapeutic tea tree cream with lemon balm, oregano & thyme. Helps relieve itching & irritation from fungus, yeast, or candida. Organic & clean formula.\n\nSoothe irritated skin naturally with our Tea Tree Cream, a therapeutic blend designed to help relieve discomfort from fungus, yeast, and candida-related skin issues. Powered by tea tree oil and a synergistic mix of botanicals, this cream delivers calming, cooling relief while supporting skin’s natural balance.\n\nFormulated with lemon balm, thyme, pau d’arco, oregano, and rosemary, plus rich shea butter and coconut oil, it hydrates deeply while helping to reduce redness, itching, and irritation. Gentle yet effective, this cream is free from harsh chemicals, parabens, phthalates, dyes, and synthetic fragrance, making it safe for daily use.\n\n✔ Helps calm itching & irritation\n✔ Fungal-fighting botanical blend\n✔ Hydrating with raw shea butter & coconut oil\n✔ Organic, cruelty-free, & gluten-free\n✔ Made in the USA with therapeutic-grade essential oils\n\nFor best results, apply 2–3 times daily to affected areas.",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:38.939Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
